import "./transfer";
import flightSearch from "./flightSearch";

export default flightSearch;
